
import { mapActions, mapGetters } from 'vuex'
import store from '../config/store'
import Pagination from "@/common/components/Pagination";

export default {
  components: {
    Pagination,
    'component-placeholder': () => import(/* webpackChunkName: "components" */ '../components/Placeholder.vue'),
    ComponentFilters: () => import(/* webpackChunkName: "components" */ '../components/Filter.vue'),
  },
  
  data: () => ({
    store,
    currentFilters: {},
    pagination: store.data.pagination,
    loading: false
  }),

  computed: {
    ...mapGetters([
      'operations',
      'operationCategories'
    ]),

    hasResult () {
      return Object.keys(this.operations).length && !this.loading
    },

    sortedOperations () {
      const operations = { ...this.operations }
      delete operations.intraday
      if (this.operations.intraday && this.operations.intraday.length) {
        return {
          intraday: this.operations.intraday,
          ...operations
        }
      }
      return { ...operations }
    }
  },

  watch: {
    'store.data.pagination.currentPage': function () {
      if (this.pagination.currentPage !== store.data.pagination.currentPage) {
        this.pagination = store.data.pagination
        this.getOperations()
      }
    },

    'store.data.user.account.uuid': function () {
      this.getOperations()
    }
  },
  
  mounted () {
    this.loading = true
    this.getOperations().then(() => {
      this.loading = false
    })
    if (!this.operationCategories.length) {
      this.getOperationCategories()
    }

    this.$bus.$on('filters', this.filters)
  },
  
  destroyed () {
    this.$bus.$off('filters', this.filters)
  },
  
  methods: {
    ...mapActions([
      'getOperations',
      'getOperationCategories'
    ]),

    addDocument (operation) {
      this.showModal({
        childVue: 'join-document',
        wrapperClass: 'modal modal--md',
        dataModel: operation
      })
    },

    hasDocument (operation) {
      return operation.documents.length
    },
    
    showDetails (operation) {
      this.showSidePanel({
        childVue: 'operation-detail',
        dataModel: operation,
        wrapperClass: 'sidepanel--md',
      })
    },

    showExportPanel () {
      this.showSidePanel({
        childVue: 'operation-export',
        dataModel: this.currentFilters,
        wrapperClass: 'sidepanel-export sidepanel--md',
      })
    },
    
    filters (filters) {
      store.data.pagination.currentPage = 1
      this.currentFilters = filters
      this.getOperations(filters)
    }
  }
}
